export const uiGridCustomStyles = `
  [ng\\:cloak],
  [ng-cloak],
  [data-ng-cloak],
  [x-ng-cloak],
  .ng-cloak,
  .x-ng-cloak,
  .ng-hide:not(.ng-hide-animate) {
    display: none !important;
  }

  ng\\:form {
    display: block;
  }

  .ng-animate-shim {
    visibility: hidden;
  }

  .ng-anchor {
    position: absolute;
  }

  .ui-grid {
    color: #4A5469;
    font-size: 14px;
    .ui-grid-top-panel,
    .ui-grid-row-header-cell,
    .ui-grid-menu-button,
    .ui-grid-footer-panel,
    .ui-grid-pager-control > button {
        background-color: #EFF1F6 !important;
    }

    .ui-grid-header-cell {
      padding: 5px 0;
      .ui-grid-header-cell > div {
          padding: 2rem !important;
      }
    }

    .ui-grid-row:nth-child(even) .ui-grid-cell {
      background-color: #F0F2F5;
    }

    .ui-grid-row:nth-child(even):hover .ui-grid-cell {
      background-color: #d5eaee;
    }

    .ui-grid-footer-info {
      font-weight: bold;
    }

    .ui-grid-custom-link-cell {
      > a {
          text-decoration: underline;
      }
    }

    .ui-grid-custom-icon-cell {
      text-align: center;
    }
    .ui-grid-menu-button .ui-grid-menu .ui-grid-menu-mid {
      overflow: auto !important;
    }

    .ui-grid-menu-button {
      height: 38px !important;
    }
  }

  .watermark-board,
  .data-loading-board {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 2rem;
    width: 100%;
    text-align: center;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .watermark-board {
    opacity: 0.25;
  }

  .data-loading-board {
    opacity: 0.5;
    color: black;
    background: white;
    height: 100%;
  }

  ui-grid-menu-button .ui-grid-menu .ui-grid-menu-mid {
    overflow: scroll;
  }

  .ui-grid-viewport {
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background: #fff;
      z-index: 999999;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: #9aa6bc;
    }
  }
`;
